import ga from "ga-lite";
import './index.css';

ga('create', 'UA-72180754-1', 'auto');
ga('send', 'pageview');


const width = 500;
const height = 500;

const c = document.getElementById("c");
const g = document.getElementById("g");

const ctx = c.getContext("2d", {alpha: false});
const idata = ctx.createImageData(width, height);
const buffer = new Uint32Array(idata.data.buffer);

const noise = (ctx) => {
  let len = buffer.length - 1;
  while(len--) {
    buffer[len] = (Math.random() < 0.5 ? 0 : -1) >> 0;
  }
  ctx.putImageData(idata, 0, 0);
}

const delay = (timeout=0) => {
  return new Promise(function(resolve) {
      setTimeout(resolve, timeout);
  });
}

const noisefor = (timeout) => {
  
  let keepGoing = true;
  
  const loop = () => {
    noise(ctx);
    if (keepGoing) {
      requestAnimationFrame(loop);
    }
  }

  c.style.display = "inline";
  loop();
  return delay(timeout).then(() => {
    keepGoing = false;
    c.style.display = "none";
  });
}

delay()
  .then(() => g.className = "up")
  .then(() => delay(500))
  .then(() => noisefor(50))
  .then(() => g.className = "")
  .then(() => noisefor(250))
  .then(() => g.className = "up")
  .then(() => delay(750))
  .then(() => g.className = "")
  .then(() => noisefor(1000))
  .then(() => document.location = "https://www.google.com");



// WEBPACK FOOTER //
// ./src/index.js